// ============ حفظ الليدز من فورمات الموقع ============
// كل ليد بيتحفظ في Firestore (collection: leads) ومعاه المكان اللي اتسجل منه في الموقع.
import { isFirebaseConfigured } from "../Data/firebaseConfig";
import { commit, docName, randomId, statsWrite, toFields } from "./firestoreRest";
import { stripLang, langFromPath } from "./i18nPaths";
import { currentTrafficSource } from "./tracking";

// أسماء أماكن التسجيل (بتظهر في الداشبورد)
export const LEAD_SOURCES = {
  "home-contact": "Home · Contact section",
  "contact-page": "Contact page",
};

// نوع الاهتمام بالإنجليزي (نفس ترتيب الأزرار في الفورم) عشان الداشبورد تبقى موحدة
export const INTERESTS_EN = ["Buy", "Sell", "Invest", "Rent"];

const clip = (s, n) => String(s || "").trim().slice(0, n);

/**
 * submitLead({ name, email, phoneCode, phone, country, message, interest, source })
 * مبتستناش الرد: الفورم بيكمل ويفتح واتساب على طول، والحفظ بيكمل في الخلفية.
 */
export const submitLead = (data) => {
  if (!isFirebaseConfigured()) return Promise.resolve(false);
  const path = window.location.pathname;
  const lead = {
    name: clip(data.name, 120),
    email: clip(data.email, 160),
    phoneCode: clip(data.phoneCode, 8),
    phone: clip(data.phone, 30),
    country: clip(data.country, 4),
    message: clip(data.message, 2000),
    interest: clip(data.interest, 60),
    source: clip(data.source, 40),
    page: clip(stripLang(path), 120),
    lang: langFromPath(path),
    referrer: clip(currentTrafficSource(), 40),
    device: /Mobi|Android/i.test(navigator.userAgent) ? "mobile" : "desktop",
  };
  return commit(
    [
      {
        update: { name: docName(`leads/${randomId()}`), fields: toFields(lead) },
        updateTransforms: [{ fieldPath: "createdAt", setToServerValue: "REQUEST_TIME" }],
        currentDocument: { exists: false },
      },
      statsWrite({ leads: 1 }),
    ],
    { keepalive: true }
  )
    .then(() => true)
    .catch(() => false);
};
